import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="hero-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-title-container">
              <img src="/logo.jpeg" alt="Shachar High-Tech Logo" className="hero-logo" />
              <div className="hero-title-text">
                <h1 className="hero-title">Shachar High-Tech</h1>
                <h2 className="hero-subtitle-title gradient-text">Software Development</h2>
              </div>
            </div>
            <p className="hero-subtitle">
              Professional software development services specializing in Cloud services, 
              Machine Learning, and Data Analysis. Over 10 years of experience delivering 
              innovative solutions for businesses worldwide.
            </p>
            <div className="hero-buttons">
              <button className="btn" onClick={scrollToContact}>
                Get Started
              </button>
              <button className="btn btn-secondary" onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}>
                Our Services
              </button>
            </div>
          </div>
          
          <div className="hero-image">
            <div className="hero-card">
              <div className="card-icon">◆</div>
              <h3>Innovation</h3>
              <p>Cutting-edge technology solutions</p>
            </div>
            <div className="hero-card">
              <div className="card-icon">⬡</div>
              <h3>Cloud Services</h3>
              <p>AWS expertise and cloud architecture</p>
            </div>
            <div className="hero-card">
              <div className="card-icon">◈</div>
              <h3>AI & ML</h3>
              <p>PyTorch & TensorFlow development</p>
            </div>
            <div className="hero-card">
              <div className="card-icon">▦</div>
              <h3>Data Analysis</h3>
              <p>Large-scale data processing</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
